import getProp from '@f/get-prop'

const validTypes = ['inbound', 'transform']

function getProject (state, workspaceSlug, projectSlug) {
  const workspaceData = getProp(`rules.${workspaceSlug}`, state) || {}
  // Some old sources have dots in their slug which means we can't use getProp
  return workspaceData[projectSlug] || {}
}

export const getRulesByProject = (state, workspaceSlug, projectSlug) => {
  const rules = getProject(state, workspaceSlug, projectSlug).data

  if (!rules) return null

  return Object.values(rules)
    .map(rule => rule.data)
    .filter(Boolean)
    .filter(rule => validTypes.indexOf(rule.type) > -1)
}
export const getRuleByType = (state, workspaceSlug, projectSlug, type) => {
  const rules = getProject(state, workspaceSlug, projectSlug).data

  if (!rules) return null

  return getProp(
    'data',
    Object.values(rules).filter(s => getProp('data.type', s) === type)[0]
  )
}
export function getRuleNavItems ({ workspaceSlug, sourceSlug }) {
  return [
    { name: 'Overview', href: `/${workspaceSlug}/rules/overview`, visible: true },
    { name: 'Log', href: `/${workspaceSlug}/rules/${sourceSlug}/log`, visible: true },
    { name: 'Transform', href: `/${workspaceSlug}/rules/${sourceSlug}/transform`, visible: true },
    { name: 'Inbound', href: `/${workspaceSlug}/rules/${sourceSlug}/inbound`, visible: true }
  ]
}
export const getActiveRuleNavItem = (items, activeSlug) => {
  return items.find(item => item.name.toLowerCase() === activeSlug) || {}
}

export const isRequestingRules = (state, workspaceSlug, projectSlug) => {
  return Boolean(getProject(state, workspaceSlug, projectSlug).isRequesting)
}

export const getRuleCountsBySourceRequest = (state, workspaceSlug, sourceSlug) => {
  const { isRequesting, didRequest, didRequestFail, error } =
    getProject(state, workspaceSlug, sourceSlug).counts || {}
  return { isRequesting, didRequest, didRequestFail, error }
}

export const getRuleCountsBySourceData = (state, workspaceSlug, sourceSlug) => {
  const counts = getProject(state, workspaceSlug, sourceSlug).counts || {}
  return counts.data || []
}



// WEBPACK FOOTER //
// ./selectors/rules.js